import { CreationToolType, SceneTypeEnum } from '@lingtu/apis/entities';
import { ToolBarEnum } from '/@/businessComponents/SmartEditor/types';
import { MATERIAL_ABILITY, MATERIAL_ABILITY_NAMES } from '/@/enums/common-editor';

// 工具路由
export enum CreationToolPathType {
  // 概念探索
  'DraftGenerate' = 'manuscript',
  // 线稿提取
  'LineExtraction' = 'line-extraction',
  // 配色参考
  'LineRefinement' = 'line-adjustment',
  // 色稿细化
  'ColorRefinement' = 'color-adjustment',
  // 成稿提质
  'Upgrade' = 'upgrade',
  // 智能编辑落地页
  'Smart' = 'smart',
}

// 类型的路由映射
export const routeToolMap = {
  [CreationToolPathType.DraftGenerate]: CreationToolType.DraftGenerate,
  //[CreationToolPathType.LineExtraction]: 'CreationToolType.LineExtraction',
  [CreationToolPathType.LineRefinement]: CreationToolType.LineRefinement,
  [CreationToolPathType.ColorRefinement]: CreationToolType.ColorRefinement,
  [CreationToolPathType.Upgrade]: CreationToolType.Upgrade,
  [CreationToolPathType.Smart]: CreationToolType.SmartEditor,
};

// 路由的类型映射
export const toolRouteMap = {
  [CreationToolType.DraftGenerate]: CreationToolPathType.DraftGenerate,
  //[CreationToolType.LineExtraction]: CreationToolPathType.LineExtraction,
  [CreationToolType.LineRefinement]: CreationToolPathType.LineRefinement,
  [CreationToolType.ColorRefinement]: CreationToolPathType.ColorRefinement,
  [CreationToolType.Upgrade]: CreationToolPathType.Upgrade,
  [CreationToolType.SmartEditor]: CreationToolPathType.Smart,
};

// 类型的标题映射
export const titleToolMap = {
  [CreationToolType.DraftGenerate]: '概念探索',
  // [CreationToolType.LineExtraction]: '线稿提取',
  [CreationToolType.LineRefinement]: '配色参考',
  [CreationToolType.ColorRefinement]: '色稿细化',
  [CreationToolType.Upgrade]: '成稿提质',
  [CreationToolType.SmartEditor]: '智能编辑',
};

// 通用类型的标题映射

export const commonTitleToolMap = MATERIAL_ABILITY_NAMES;

// 类型的tab选项映射
export const tabsToolMap = {
  [CreationToolType.DraftGenerate]: CreationToolType.DraftGenerate,
  //[CreationToolType.LineExtraction]: CreationToolType.LineExtraction,
  [CreationToolType.LineRefinement]: CreationToolType.ColorRefinement,
  [CreationToolType.ColorRefinement]: CreationToolType.ColorRefinement,
  [CreationToolType.Upgrade]: CreationToolType.Upgrade,
};

// 关键字段中文映射
export const moduleTitleMap = {
  type: '类型',
  style: '风格',
};

// 场景标题映射
export const sceneTypeTitle = {
  [SceneTypeEnum.Scenario]: '游戏场景',
  [SceneTypeEnum.Standalone]: '游戏单体建筑',
};

export const transparentUrl =
  'https://static.lingvisions.com/public/70fa4c19ec2741a3be36cbf14746cfdb.png';
